import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createStaticVNode as _createStaticVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/images/mine/shareHead.png';

const _withScopeId = n => (_pushScopeId("data-v-4707dbfe"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "shareFreeWatch"
};
const _hoisted_2 = {
  class: "head_titles"
};
const _hoisted_3 = {
  class: "cont webkit-overflow-scrolling-touch"
};
const _hoisted_4 = {
  class: "img_text"
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "shareHead",
  src: _imports_0,
  alt: ""
}, null, -1));

const _hoisted_6 = {
  class: "rwm_box"
};

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "user-share-qrcode-prompt"
}, " *好友也可在个人中心直接填写你的邀请码 ", -1));

const _hoisted_8 = {
  class: "user-share-btn-box"
};
const _hoisted_9 = ["data-clipboard-text"];

const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"user-share-describe\" data-v-4707dbfe><div class=\"user-share-describ-title\" data-v-4707dbfe>推广福利</div><div class=\"user-share-describ-text\" data-v-4707dbfe>邀请好友免费看片</div><div class=\"user-share-describ-title\" data-v-4707dbfe>推广说明</div><div class=\"user-share-describ-text\" data-v-4707dbfe> 問 : 怎樣才算邀請成功？<br data-v-4707dbfe>答 : 發送推廣聯接給其它新用戶，新用戶正式注冊，即绑定手机就算分享成功。<br data-v-4707dbfe>问：为什么推广链接别人打不开？<br data-v-4707dbfe>答：请勿使用微信或者QQ等第三方内置浏览器打开，因为包含 色情内容导致被屏蔽，推荐使用自带浏览器或UC等浏览器打开。 <br data-v-4707dbfe> 问：如何分享免费看呢？ <br data-v-4707dbfe> 答：每天分享，每天领取，每分享一人，赠送一天，无限累加。 </div></div>", 1);

const _hoisted_11 = {
  class: "promotionRecord"
};
const _hoisted_12 = {
  class: "head_titles"
};

const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "推广记录", -1));

const _hoisted_14 = {
  class: "cont_body"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_icon = _resolveComponent("van-icon");

  const _component_qrcode_vue = _resolveComponent("qrcode-vue");

  const _component_promotion_record = _resolveComponent("promotion-record");

  const _component_van_popup = _resolveComponent("van-popup");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_van_icon, {
    size: "22",
    name: "arrow-left",
    onClick: _cache[0] || (_cache[0] = $event => $setup.close(1))
  }), _createElementVNode("span", {
    class: "title",
    onClick: _cache[1] || (_cache[1] = (...args) => $setup.toDetails && $setup.toDetails(...args))
  }, "邀请记录")]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", _hoisted_6, [_createVNode(_component_qrcode_vue, {
    value: $setup.qrUrl2,
    size: 170,
    level: "H"
  }, null, 8, ["value"]), _createElementVNode("p", null, "我的推广码：" + _toDisplayString($setup.userInfo.invite_code), 1)]), _hoisted_7]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", {
    class: "user-share-btn-link copy",
    "data-clipboard-text": $setup.qrUrl,
    onClick: _cache[2] || (_cache[2] = (...args) => $setup.copy && $setup.copy(...args))
  }, " 复制链接分享 ", 8, _hoisted_9), _createElementVNode("div", {
    class: "user-share-btn-img",
    onClick: _cache[3] || (_cache[3] = (...args) => $setup.downImg && $setup.downImg(...args))
  }, "保存图片分享")]), _hoisted_10])]), _createVNode(_component_van_popup, {
    show: $setup.showDetailsPopul,
    "onUpdate:show": _cache[5] || (_cache[5] = $event => $setup.showDetailsPopul = $event),
    class: "popup_coentent",
    overlay: false,
    position: "right"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createVNode(_component_van_icon, {
      size: "22",
      name: "arrow-left",
      onClick: _cache[4] || (_cache[4] = $event => $setup.close(2))
    }), _hoisted_13]), _createElementVNode("div", _hoisted_14, [(_openBlock(), _createBlock(_component_promotion_record, {
      key: new Date().getTime()
    }))])])]),
    _: 1
  }, 8, ["show"])], 64);
}